import styled from 'styled-components';

const Formulario = styled.form`
    padding: 40px;
    border-radius: 20px;
    box-shadow: 0 0 42px 0 rgba(0, 0, 0, 0.1);
`;

export default Formulario;
